<template>
    <div class="panel">
        <div class="sedes">
            <button v-for="(item, index) in sedes" :key="index" class="sede" @click="openHabs(item)">{{ item }}</button>
        </div>
        <div class="habs">

        </div>
    </div>
</template>

<script>
import API from '@/api'

export default {
    name: 'panel',
    data() {
        return {
            sedes: []
        }
    },
    methods: {
        getSedes() {
            API.getSedesList()
                .then((res) => {
                    this.sedes = res
                })
        },
        openHabs(sede) {
            API.getHabsBySede(sede)
                .then((res) => {

                })
        }
    },
    mounted() {
        this.getSedes()
    }
}
</script>

<style scoped>
    .panel {
        width: 100%;
        height: 90vh;
        display: flex;
    }
    .sedes {
        width: 20%;
        height: 100%;
        background-color:aquamarine;
        border-right-style: double;
    }
    .habs {
        width: 80%;
        height: 100%;
        background-color: #e0b059;
    }
    .sede {
        margin-left: 30px;
        margin-top: 35px;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 80%;
        height: 60px;
        border-radius: 25px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Habitaciones/Panel.vue